import React, { useEffect, useRef, useState } from 'react';
import s from "./DeviceInfo.module.css";
import dayjs, { Dayjs } from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import 'dayjs/locale/ru';
import { getDevDetailReports, exportTemplatesXLSX } from "../../Api//ReportsApi";
import { exportDeviceToExcel } from "../../Api//DevicesApi";
import { formatDateUnix } from '../../utils/date';
import { SoloDateCalendarViews } from 'Components/Reports/ReportUtils';

dayjs.extend(utc);
dayjs.extend(timezone);

export const ConsumptionTable = ({ deviceId, templates, org, dev_type }) => {
    const [data, setData] = useState(null);
    const [showPopup, setShowPopup] = useState(false);
    const [filteredData, setFilteredData] = useState(null);
    const [sortOrder, setSortOrder] = useState('desc');

    const headers = ['Дата показаний', 'Общее потребление', 'Потребление']

    const [startDate, setStartDate] = useState(dayjs().startOf('month'));
    const [endDate, setEndDate] = useState(dayjs().endOf('month'));


    const [selectedOption, setSelectedOption] = useState('current');

    const handleSelection = (event) => {
        const selected = event.target.value;
        setSelectedOption(selected);
    };

    useEffect(() => {
        const fetchData = async () => {
            if (deviceId) {
                const startDateISO = dayjs(startDate).tz('Europe/Minsk').startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS')
                let endDateISO;
                if (selectedOption === 'current') {
                    endDateISO = dayjs(endDate).tz('Europe/Minsk').endOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS')
                } else if (selectedOption === 'startOfDay') {
                    endDateISO = dayjs(endDate).tz('Europe/Minsk').endOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS')
                } else if (selectedOption === 'startOfMonth') {
                    if (dev_type === 'СС101') {
                        endDateISO = dayjs(endDate).tz('Europe/Minsk').startOf('month').format('YYYY-MM-DDTHH:mm:ss.SSS')
                    }
                    else {
                        endDateISO = dayjs(endDate).tz('Europe/Minsk').endOf('month').format('YYYY-MM-DDTHH:mm:ss.SSS')
                    }
                } else if (selectedOption === 'startOfYear') {
                    endDateISO = dayjs(endDate).tz('Europe/Minsk').startOf('year').format('YYYY-MM-DDTHH:mm:ss.SSS')
                } else {
                    endDateISO = dayjs(endDate).tz('Europe/Minsk').endOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS')
                }

                const result = await getDevDetailReports(deviceId, startDateISO, endDateISO, selectedOption);
                setData(result);
            }
        };
        fetchData();
    }, [deviceId, startDate, endDate, selectedOption]);

    const popupRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (popupRef.current && !popupRef.current.contains(event.target) && !event.target.closest(`.${s.downland}`)) {
                setShowPopup(false);
            }
        };
        if (showPopup) {
            document.addEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showPopup]);

    useEffect(() => {
        if (data && data[0]) {
            const filtered = data[0].result.filter((value) => {
                const timestamp = new Date(value.device_frmpayload_data_timestamp * 1000);
                const fromDateTimestamp = new Date(startDate);
                const toDateTimestamp = new Date(endDate);
                fromDateTimestamp.setHours(0, 0, 0, 0);
                toDateTimestamp.setHours(23, 59, 59, 999);
                return timestamp >= fromDateTimestamp && timestamp <= toDateTimestamp;
            });
            
            const sorted = [...filtered].sort((a, b) => {
                const timeA = a.device_frmpayload_data_timestamp;
                const timeB = b.device_frmpayload_data_timestamp;
                return sortOrder === 'asc' ? timeA - timeB : timeB - timeA;
            });
            
            setFilteredData(sorted);
        }
    }, [data, startDate, endDate, sortOrder]);

    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemPerPage] = useState(5);

    let quantity = 0;
    if (filteredData) {
        quantity = filteredData.length;
    }

    let totalPages = 0;
    if (filteredData) {
        totalPages = Math.ceil(filteredData.length / itemsPerPage);
    }

    const handlePreviousPage = () => {
        setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
    };

    const handleNextPage = () => {
        if (totalPages > 1) {
            setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages));
        }
    };

    const handleItemsPerPageChange = (event) => {
        setItemPerPage(Number(event.target.value));
        setCurrentPage(1);
    };

    const toggleSortOrder = () => {
        setSortOrder(prevOrder => prevOrder === 'asc' ? 'desc' : 'asc');
        setCurrentPage(1);
    };

    const handleExportXLSX = () => {

        const startDateISO = dayjs(startDate).tz('Europe/Minsk').startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS')
        let endDateISO;
        if (selectedOption === 'current') {
            endDateISO = dayjs(endDate).tz('Europe/Minsk').endOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS')
        } else if (selectedOption === 'startOfDay') {
            endDateISO = dayjs(endDate).tz('Europe/Minsk').endOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS')
        } else if (selectedOption === 'startOfMonth') {
            if (dev_type === 'СС101') {
                endDateISO = dayjs(endDate).tz('Europe/Minsk').startOf('month').format('YYYY-MM-DDTHH:mm:ss.SSS')
            }
            else {
                endDateISO = dayjs(endDate).tz('Europe/Minsk').endOf('month').format('YYYY-MM-DDTHH:mm:ss.SSS')
            }
        } else if (selectedOption === 'startOfYear') {
            endDateISO = dayjs(endDate).tz('Europe/Minsk').startOf('year').format('YYYY-MM-DDTHH:mm:ss.SSS')
        } else {
            endDateISO = dayjs(endDate).tz('Europe/Minsk').endOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS')
        }

        const dataToExport = {
            filteredData,
            data,
            selectedOption,
            startDateISO,
            endDateISO
        };
        exportDeviceToExcel({ dataToExport })
            .then(() => {
                console.log('Данные успешно отправлены для отчета за период');
            })
            .catch(error => {
                console.error('Ошибка отправки данных для отчета за период:', error);
            });
    };

    const handleButtonClick = () => {
        if (data) {

            const device = data[0].device;
            const devType = device.dev_type;

            if (devType === 'ТС') {
                setShowPopup((prev) => !prev);
            } else {
                handleExportXLSX();
            }
        }
    };

    const handleExportClick = (template) => {
        handleExportTemplateXLSX(template);
        setShowPopup(false);
    };

    const handleExportTemplateXLSX = (template) => {
        const startDateISO = dayjs(startDate).tz('Europe/Minsk').startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS')
        let endDateISO;
        if (selectedOption === 'current') {
            endDateISO = dayjs(endDate).tz('Europe/Minsk').endOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS')
        } else if (selectedOption === 'startOfDay') {
            endDateISO = dayjs(endDate).tz('Europe/Minsk').endOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS')
        } else if (selectedOption === 'startOfMonth') {
            if (dev_type === 'СС101') {
                endDateISO = dayjs(endDate).tz('Europe/Minsk').startOf('month').format('YYYY-MM-DDTHH:mm:ss.SSS')
            }
            else {
                endDateISO = dayjs(endDate).tz('Europe/Minsk').endOf('month').format('YYYY-MM-DDTHH:mm:ss.SSS')
            }
        } else if (selectedOption === 'startOfYear') {
            endDateISO = dayjs(endDate).tz('Europe/Minsk').startOf('year').format('YYYY-MM-DDTHH:mm:ss.SSS')
        } else {
            endDateISO = dayjs(endDate).tz('Europe/Minsk').endOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS')
        }

        const dataToExport = {
            deviceId,
            org,
            template,
            startDateISO,
            endDateISO
        };
        exportTemplatesXLSX({ dataToExport })
            .then(() => {
                console.log('Данные успешно отправлены для отчета за период');
            })
            .catch(error => {
                console.error('Ошибка отправки данных для отчета за период:', error);
            });
    };

    return (
        <>
            <div className={s.warp}>
                <div className={s.actionTable}>
                    <div className={s.tableTitle}>Таблица потребления</div>
                    <select className={s.tableSelect} onChange={handleSelection}>
                        <option value="current">Мгновенные</option>
                        <option value="startOfDay">По дням</option>
                        <option value="startOfMonth">По месяцам</option>
                    </select>
                    <SoloDateCalendarViews startDate={startDate} endDate={endDate} setStartDate={setStartDate} setEndDate={setEndDate} aggregateData={selectedOption} />
                </div>
                <div className={s.divTable}>
                    <table className={s.table}>
                        <thead>
                            <tr>
                                {headers.map((header, index) => (
                                    <th key={index} onClick={index === 0 ? toggleSortOrder : undefined} style={index === 0 ? { cursor: 'pointer' } : {}}>
                                        <div className={s.tableText}>
                                            {header}
                                            {index === 0 && (
                                                <span style={{ marginLeft: '8px', fontSize: '12px' }}>
                                                    {sortOrder === 'asc' ? '↑' : '↓'}
                                                </span>
                                            )}
                                        </div>
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            <PaginationTable filteredData={filteredData} data={data} currentPage={currentPage} itemsPerPage={itemsPerPage} />
                        </tbody>
                    </table>
                </div>
                <div className={s.foterWrap}>
                    <div className={s.downland} onClick={handleButtonClick}>
                        <img src={'/downland.svg'} alt="download" />
                        <div className={s.downlandText}>Экспорт данных</div>
                        {showPopup && (
                            <div className={s.popup} ref={popupRef}>
                                <div className={s.popupContent}>
                                    {templates.map((header, index) => (
                                        <div className={s.downlandButton} key={index} onClick={() => handleExportClick(header)}>
                                            <div className={s.downlandText}>{header}</div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                    <div className={s.paginate}>
                        <div className={s.paginateText}>{quantity} всего</div>
                        <div className={s.devicePerPage}>
                            <div className={s.devicePerPageText}>Показать</div>
                            <select className={s.inputPerPage} value={itemsPerPage} onChange={handleItemsPerPageChange}>
                                <option value="5">5</option>
                                <option value="15">15</option>
                                <option value="30">30</option>
                                <option value="50">50</option>
                            </select>
                        </div>
                        <div className={s.paginateInput}>
                            <div className={s.arrowLeft} onClick={handlePreviousPage}>
                                <img src={'/arrowleft.svg'} alt="prev" />
                            </div>
                            <div className={s.page}>{currentPage}</div>
                            <div className={s.arrowRight} onClick={handleNextPage}>
                                <img src={'/arrowright.svg'} alt="next" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

const PaginationTable = ({ filteredData, data, currentPage, itemsPerPage }) => {
    if (!filteredData || filteredData.length === 0) {
        return <p>Нет данных на данный промежуток</p>;
    }

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    const renderItems = currentItems.map((value, i) => {

        const datetime = formatDateUnix(value.device_frmpayload_data_timestamp);
        const [date, time] = datetime.split(',');
        const baseVolume = Number(value.device_frmpayload_data_volume) + Number(data[0].data.start_volume || 0);
        let volume = baseVolume * Number(data[0].device.factor || 1);
        const differenceValue = value.device_frmpayload_data_volume_diff || 0;
        let consumption = Number(differenceValue) * Number(data[0].device.factor || 1);
        consumption = consumption.toFixed(3)
        consumption += `${data[0].device.dev_type === 'ВС' ? ' м³' : data[0].device.dev_type === 'ТС' ? ' ГДж' : data[0].device.dev_type === 'ГС' ? ' м³' : ' кВт-Ч'}`;
        volume = volume.toFixed(3);
        volume += `${data[0].device.dev_type === 'ВС' ? ' м³' : data[0].device.dev_type === 'ТС' ? ' ГДж' : data[0].device.dev_type === 'ГС' ? ' м³' : ' кВт-Ч'}`;

        return (
            <tr key={i}>
                <td className={s.datetime}>
                    <div className={s.tableDate}>{date}</div>
                    <div className={s.tableTime}>{time}</div>
                </td>
                <td className={s.tableBodyText}>{volume}</td>
                <td className={s.tableBodyText}>{consumption}</td>
            </tr>
        );
    })

    return <>{renderItems}</>;
};


